<template>
    <div class="time-input">
        <DurationInput
            v-if="mode === 'edit'"
            ref="refTimeInput"
            :value="currentValue"
            :placeholder="placeholderFormat"
            :lazyMask="true"
            :useSecond="useSecond"
            @update:value="(updatedValue) => (currentValue = updatedValue)"
        />
        <p v-else>
            {{ currentValue }}
        </p>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import DurationInput from 'vcomponents/inputs/DurationInput.vue';
const corpMapState = createNamespacedHelpers('corp').mapState;
export default {
    components: { DurationInput },
    component: {
        DurationInput,
    },
    props: {
        mode: {
            type: String,
        },
        value: {
            type: [Date, String],
            required: false,
            default: false,
        },
        type: {
            type: String,
            required: false,
            default: 'text',
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            currentValue: '',
            defaultValue: new Date.now().setHours(0, 0),
        };
    },
    computed: {
        ...corpMapState(['timetracking']),
        placeholderFormat() {
            if (this.placeholder.length) {
                return this.placeholder;
            }
            return this.useSecond ? '00:00:00' : '00:00';
        },
        useSecond() {
            return this.timetracking.usePrecisionSecond === 'Y';
        },
    },
    watch: {
        currentValue(newValue) {
            this.$emit('input', this.useSecond ? this.currentValue : this.currentValue + ':00');
        },
    },
    created() {
        this.currentValue = this.useSecond
            ? this.value
            : this.value.split(':').slice(0, 2).join(':');
    },
    methods: {
        // eslint-disable-next-line vue/no-unused-properties
        setFocus() {
            this.$refs.refTimeInput?.$refs?.input?.$refs?.compassInput?.focus();
        },
    },
};
</script>

<style scoped lang="scss">
.time-input > .compass-input {
    width: 100%;
}
</style>
